
import {classList} from '../index';

const Loading = () => (
    <div className={classList.cartEmpty}>
        <p className="loading">Loading...</p>
    </div>
);

export default Loading;